import { put } from 'redux-saga/effects';
import { Types, IFabricationOrder, IDownloadNFEResponse } from './types';
import {
  loadFabricationOrdersSuccess,
  loadFabricationOrdersFailure,
  loadNFFileFromFabricationOrderDeliverySuccess,
  loadNFFileFromFabricationOrderDeliveryFailure,
  loadFabricationOrderByIdSagaSuccess,
  loadFabricationOrderByIdSagaFailure
} from './actions';
import { FabricationOrdersService } from '../../../services/FabricationOrders';
import { FabricationContractsService } from '../../../services/FabricationContracts';
import { IFabricationContract } from '../fabrication-contracts/types';
import { loadContractByContractNumberSuccess } from '../fabrication-contracts/actions';
import { EToastTypes } from '../toast/types';
import { addToast } from '../toast/actions';

interface ILoadFabricationOrdersParams {
  payload: {
    selectedContractNumbers: string[];
    startDate: moment.Moment;
    endDate: moment.Moment;
    needToLoadContract?: boolean;
  };
  type: Types;
}

interface ILoadFabricationOrderFromIdSaga {
  payload: {
    orderId: number;
  };
  type: Types;
}

interface ILoadNFParams {
  payload: {
    deliveryId: number;
    fabricationOrderId: number;
    danfeNumber: string;
  };
  type: Types;
}

export function* loadFabricationOrdersSaga(
  params: ILoadFabricationOrdersParams
) {
  const { selectedContractNumbers, startDate, endDate, needToLoadContract } =
    params.payload;

  if (needToLoadContract) {
    try {
      const fabricationContractsService = new FabricationContractsService();
      const contract: IFabricationContract =
        yield fabricationContractsService.getContractDetails(
          selectedContractNumbers[0]
        );
      yield put(loadContractByContractNumberSuccess(contract));
    } catch (err) {
      yield put(loadFabricationOrdersFailure(undefined, true));
      return;
    }
  }

  try {
    const fabricationOrderService = new FabricationOrdersService();
    const fabricationOrders: IFabricationOrder[] =
      yield fabricationOrderService.getFabricationOrders(
        selectedContractNumbers,
        startDate.format('YYYY-MM-DD'),
        endDate.format('YYYY-MM-DD')
      );

    yield put(loadFabricationOrdersSuccess(fabricationOrders));
  } catch (err) {
    console.error('loadFabricationOrdersSaga', err);
    yield put(loadFabricationOrdersFailure(err));
    yield put(
      addToast({
        message: 'Falha ao buscar os pedidos.',
        type: EToastTypes.DANGER
      })
    );
  }
}

export function* loadNFFileFromFabricationOrderDeliverySaga(
  params: ILoadNFParams
) {
  const { deliveryId, fabricationOrderId, danfeNumber } = params.payload;
  try {
    const fabricationOrderService = new FabricationOrdersService();
    const downloadNFEResponse: IDownloadNFEResponse =
      yield fabricationOrderService.loadNFEFileFromFabricationOrderDelivery(
        danfeNumber
      );

    yield put(
      loadNFFileFromFabricationOrderDeliverySuccess(
        fabricationOrderId,
        deliveryId,
        downloadNFEResponse
      )
    );
  } catch (err) {
    console.error('loadNFFileFromFabricationOrderDeliverySaga', err);
    yield put(
      addToast({
        message: 'Falha ao baixar a Nota fiscal.',
        type: EToastTypes.DANGER
      })
    );
    yield put(
      loadNFFileFromFabricationOrderDeliveryFailure(
        fabricationOrderId,
        deliveryId,
        err
      )
    );
  }
}

export function* loadFabricationOrderByIdSaga(
  params: ILoadFabricationOrderFromIdSaga
) {
  const { orderId } = params.payload;
  try {
    const fabricationOrderService = new FabricationOrdersService();
    const fabricationOrder: IFabricationOrder =
      yield fabricationOrderService.getFabricationOrderFromId(orderId);

    yield put(loadFabricationOrderByIdSagaSuccess(fabricationOrder));
  } catch (err) {
    console.error('loadFabricationOrderByIdSaga', err);
    yield put(loadFabricationOrderByIdSagaFailure(orderId, err));
  }
}
